<template>
  <section class="min-h-screen lg:grid lg:grid-cols-[1fr_minmax(0,34rem)] bg-ink-950">
    <!-- Capa: topo no celular, metade esquerda no desktop -->
    <div class="relative h-[46vh] min-h-[18rem] lg:h-auto lg:min-h-screen overflow-hidden">
      <img class="absolute inset-0 h-full w-full object-cover object-[center_30%] lg:object-center" src="@/assets/capanova.jpg"
        alt="Calvobet">
      <div class="absolute inset-0 bg-gradient-to-b from-ink-950/10 via-transparent to-ink-950 lg:bg-gradient-to-r lg:from-transparent lg:via-transparent lg:to-ink-950"></div>
    </div>

    <div class="relative -mt-16 lg:mt-0 flex flex-col justify-center px-6 pb-12 lg:py-12 sm:px-12">
      <div class="w-full max-w-sm mx-auto">
        <slot></slot>
      </div>
    </div>
  </section>
</template>
